module.exports = __webpack_public_path__ + "static/img/Group 40367.8b5fe338.svg";